import http from "./httpService";
import {AuthService, MarketService} from "./index";

const apiEndpoint = process.env.REACT_APP_API_PROSPECTSALESTOOL_URL + "/Common";

export async function AuditUserActions(screen, action, fileName, market_ids, content_id,user_audit,topic_name) {
  let userId= AuthService.isSuperAdmin()?"":AuthService.getUserId()
  let markets=await MarketService.GetMarkets(userId)
  const marketIds = markets.data.Data.map((market)=>{
    return market.id
  })
  http.addBearerAuthorization();  
  const requestObj = {
    "screen": screen,
    "action": action,
    "user_id": localStorage.getItem('user_id'),
    "market_ids": market_ids ? market_ids : AuthService.isSuperAdmin() ? null : marketIds,
    "filename": fileName,
    "content_id": content_id ? content_id : '00000000-0000-0000-0000-000000000000',
    "user_audit":user_audit,
    "topic_name":topic_name,
  }
  return await http.post(apiEndpoint + "/GetCommonAudit", requestObj);
}

export default {
  AuditUserActions
};
